import regionConfig from 'src/config';

const Messages = {
    NETWORK_ERROR: 'Network Error',
    TOKEN_EXPIRED: 'Session Expired. Please login again.',
    UNKNOW_ERROR: 'Some error occurred. Please try again later.',
    NO_INTERNET: 'No Internet',
    DEVICE_SETTING_TITLE: 'Devices Settings',
    DEVICE_SETTING: {
        CAMERA: {
            TITLE: 'Camera',
        },
        MICROPHONE: {
            TITLE: 'Microphone',
        },
        SPEAKER: {
            TITLE: 'Speaker',
        },
    },
    CAMERA_MICROPHONE_BLOCKED: `
        Camera is blocked. To make and receive calls,<br/>
        please allow camera access in your browser settings and reload this page.
    `,
    CAMERA_MICROPHONE_DISABLED: `
        Camera is currently disabled. To make and receive calls,<br/>
        please enable the camera below.
    `,
    CAMERA_MICROPHONE_USED_BY_OTHER_APP: `
        Your camera is in use by another app. To use the camera,<br/>
        please quit the other app using video and reload this page.
    `,
    INCOMING_CALL_CAMERA_BLOCKED: `
        Camera is blocked. To answer this call,<br/>
        please allow camera access in your browser settings.
    `,
    INCOMING_CALL_CAMERA_USED_BY_OTHER_APP: `
        Camera is in use by another app. To answer this call, <br/>
        please quit the other app using video.
    `,
    VCO_MICROPHONE_BLOCKED: `
    Microphone is blocked. To use VCO, please end this call and allow access to the microphone in your browser settings and reload the page.
    `,
    VCO_SETTINGS_MICROPHONE_BLOCKED: `
    Microphone is blocked. To use VCO, please allow access to the microphone in your browser settings and reload this page.
    `,
    CAMERA_NOT_CONNECTED: `The camera is not connected. To make and receive calls, please connect your camera and reload this page.`,
    INCOMING_CALL_CAMERA_NOT_CONNECTED: `The camera is not connected. To answer incoming calls, please connect your camera.`,
    PASSWORD_INFO:
        'Password must have at least 10 characters, including 1 capital letter and 1 number.',
    CAMERA_TURNED_OFF: 'Camera is turned off.',
    WEBSOCKET_BLOCKED: `Your connection may be blocking Convo. Try a different network or ask IT to allow WebSocket connections to ${regionConfig.domain}.`,
    LINK_ALREADY_USED: 'This link has already been used — taking you to log in…',
    CONNECT_TIMEOUT: `We're sorry, something went wrong. Please refresh the page, login again, and contact Convo Support if you need assistance.`,
    SWITCH_DEVICE_OFFER_MESSAGE: 'Accept switch from other device?',
    SWITCHED_TO_DEVICE_MESSAGE: (deviceName: string) => `Switched to ${deviceName}.`,
    SWITCH_DEVICE_OFFER_NOTIFICATION_TITLE: 'Continue your call here?',
    SWITCH_DEVICE_OFFER_NOTIFICATION_BODY:
        "You're moving your call to this device. Click to accept.",
    SWITCH_DEVICE_REQUEST_SENT_MESSAGE: (deviceName: string) =>
        `Switch request sent to ${deviceName}.`,
    SWITCH_DEVICES_LOAD_ERROR: "Your devices couldn't load. Select Switch to try again.",
};

export default Messages;
